import { SendEmail } from '../send-email/SendEmail';

export const SendInviteEmail = () => {
	return (
		<>
			<SendEmail templateKey="EXAM_MODULE_REGISTRATION_INVITE_EMAIL_TEMPLATE" />
		</>
	);
};
